<template>
    <div id="boeken">
        <div class="bookingheader">
            <Header :cruise="cruise" :activeStep="activeStep"   v-on:step-minus-click="activeStep--" v-if="starterPackReceived" />

        </div>
        <div
            style="box-shadow: inset 0 3px 4px 0 rgba(0,0,0,0.24), inset 0 0 0px 0 rgba(0,0,0,0.12);"
            class="greybg"
            v-if="starterPackReceived"
        >

          <div class="stepheader" v-if="starterPackReceived">
            <div>
              <div v-for="(title, key) in {
                  1 : { number: 1 , title: 'Reisgezelschap' },
                  2 : { number: 2 , title: 'Hutkeuze' },
                  3 : { number: 3 , title: 'Tarief' },
                   4 : { number: 4 , title: 'Hutnummer' },
                   6 : { number: !cruise.isLocalDeparture ? 5 : 0 , title: 'Extra\'s' },
                   8 : { number: !cruise.isLocalDeparture ? 6 : 5 , title: 'Gegevens' },
                    9 : { number: !cruise.isLocalDeparture ? 7 : 6  , title: 'Bevestigen' },
                    }"
                   v-if="title.number !== 0">
                <NumberHeaderSmall

                    v-on:click.native="setPeopleAndStep(parseInt(key))"
                    :numberFake="parseInt(title.number)"
                    :number="parseInt(key)"
                    :activeStep="activeStep"
                    :title="title.title"
                    :subtitle="''"
                />
              </div>
            </div>

          </div>
            <div id="content">

              <div class="rotate-on-mobile">
                <div class="flex-container flex-column maincontent floatleft">
                  <div v-if="(discountaction || euroaanbetaling || campaignaction) && discountactiontext && discountactiontitle" class="notification-cabin" style="width:100%; margin-top:0; margin-bottom:30px !important;color: #248504; background: #e4f0e1; border-color: #e4f0e1; display: flex">
                    <div v-if="discountaction || euroaanbetaling" style=" margin: 10px;margin-right: 25px; display: flex; flex-flow:column; justify-content: center">
                      <img v-if="discountaction" src="https://cdn.cruisereizen.nl/Boek-online-100-korting.png" style="width:60px;max-width:initial" >
                      <img v-else-if="euroaanbetaling" src="https://cdn.cruisereizen.nl/cr_euro_aanbetaling_links.png" style="width:60px;max-width:initial" >
                    </div>
                    <div style="color: #248504; display: flex; flex-flow:column; justify-content: center">
<p style="color: #248504 !important;font-size:16px;line-height:24px;">  <b style="font-size:18px;">{{ discountactiontitle }}</b> <br>
  {{ discountactiontext }}
</p>

                    </div>
                  </div>

                <div class="booksteps" v-show="activeStep === 1">
                    <CabinConfigStep
                        :number="1"
                        :activeStep="activeStep"
                        :setActiveStep="setActiveStep"
                        :setPeopleAndStep="setPeopleAndStep"
                        :payload="payload"
                        :cruise="cruise"
                        :changeCompany="changeCompany"
                        :changeBirthdateCompany="changeBirthdateCompany"
                        :resetCabinConfig="resetCabinConfig"
                        :minAdult="minAdult"
                    />


                </div>
                  <div class="booksteps"  v-show="activeStep === 2">
                    <NumberHeader
                        v-on:click.native="setPeopleAndStep(2)"
                        :number="2"
                        :activeStep="activeStep"
                        :title="'Kies een hut'"
                        :subtitle="
                            'Gaat je voorkeur uit naar een binnenhut, buitenhut, balkonhut of suite? Selecteer hier een type hut.'
                        "
                    />

                    <div
                        v-if="activeStep === 2"
                        :class="{
                            hide: activeStep !== 2,
                            show: activeStep === 2,
                        }"
                    >
                      <div v-if="!availabilityReceived || !availableRates || ajaxCalls !== 0 ">
                        <div class=" floatleft relative width100 cabin-wrapper">
                          <div class="cabin-container">
                            <div class="item hoverme dim loadingbg" v-for="x in [1,2,3,4]">
                              <div class="midblock width100" >
                                <div style="width:100%;height:150px;" class="fakebox">
                                </div>
                                <div class="padding20 textcenter"><span
                                    class="font16 bold">Binnenhut</span><br><br><span
                                    class="width100 marginbottom10"><h3 class="darkblue bold"
                                                                        style="font-weight: normal;"><small>vanaf</small> € 749,- <small>p.p.</small></h3><button
                                    type="button" id="testCabinTypeBinnenhut"
                                    class="btn btn-success btn-addon width100 font14 bold uppercase floatleft"> Selecteer </button></span>
                                  <!---->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div v-else class="cabin-wrapper">
                            <div
                                class="cabin-container"
                                id="cabin-select"
                                v-on:scroll="
                                    scrollElement('#cabin-select', false)
                                "
                            >

                                <div
                                    v-for="(cabinType,
                                    hutIndex) in cabinTypes.collection"
                                    :key="hutIndex"
                                    v-on:click="changeCabinType(cabinType.text)"
                                    :class="{
                                        dim: true,
  soldout: !lowestRateForCabinType(cabinType.text) && !(!availabilityReceived || ajaxCalls > 0),
  mostsold: cabinType.text === 'Balkonhut',
  isdiscount: discountaction
}"
                                    class="item hoverme"
                                >
                                    <CabinTypeSelect
                                        :cabinType="cabinType"
                                        :index="hutIndex"
                                        :cruise="cruise"
                                        :payload="payload"
                                        :availabilityReceived="
                                            availabilityReceived
                                        "
                                        :ajaxCalls="ajaxCalls"
                                        :euroaanbetaling="euroaanbetaling"
                                        :discountaction="discountaction"
                                        :campaignaction="campaignaction"
                                        :lowestRateForCabinType="
                                            lowestRateForCabinType
                                        "
                                        :roundPrice="roundPrice"
                                    />
                                </div>

                            </div>
                          <div v-if="discountaction" style="margin-top:10px;">
                            <p>*De getoonde prijzen zijn nog exclusief korting. Selecteer jouw hut om zo de korting te berekenen!</p>
                          </div>
                        </div>
                    </div>

                    <div v-else-if="activeStep > 2" class="midblock floatleft relative width100">
                        <div class="padding15 textleft dim">
                            <div class="floatleft margintop10">
                                Geselecteerde hut:
                                <b>{{ payload.cabins[0].cabinType }}</b>
                            </div>
                            <button
                                v-on:click="setPeopleAndStep(2)"
                                type="button"
                                id="teststap2wijzigen"
                                class="btn btn-success btn-addon font14 bold floatright editbutton"
                            >
                                Wijzigen
                            </button>

                            <div class="clearfix"></div>
                        </div>
                    </div>

                  </div>
                  <div class="booksteps"  v-show="activeStep === 3">
                    <NumberHeader
                        v-on:click.native="setPeopleAndStep(3)"
                        :number="3"
                        :activeStep="activeStep"
                        :title="'Kies je actie'"
                        :subtitle="
                            'De meeste cruises zijn standaard op basis van volpension (ontbijt, lunch en diner) en exclusief fooien, tenzij anders vermeld' +
                             '. Er zijn verschillende tarieven beschikbaar. ' +
                              'Bekijk en vergelijk de verschillende tarieven en kies voor het tarief dat jou het meeste voordeel geeft. ' +
                               'Indien er leuke extra\'s inbegrepen zijn, zoals een drankenpakket, dan vind je deze hier terug!'
                        "
                    />

                    <div
                        v-if="activeStep === 3"
                        :class="{
                            hide: activeStep !== 3,
                            show: activeStep === 3,
                        }"
                        class=" floatleft relative width100 marginbottom20"
                    >
                      <div v-if="isOffice" style="color: red;" v-on:click="toggleIPAccess()">
                        LET OP: JE ZIET <span v-if="!showHiddenRates"> GEEN </span> HIDDEN/INVALID RATES (Office only) KLIK OM TE <span v-if="!showHiddenRates"> TONEN </span><span v-if="showHiddenRates"> VERBERGEN </span>
                      </div>

                        <div
                            v-if="
                                availabilityReceived &&
                                    availableRates &&
                                    Object.keys(availableRates).length > 0 &&
                                    ajaxCalls === 0
                            "
                            class=" textleft action-selection"
                        >
                          <div class="notification-cabin">
                            <p><b>Tip vanuit CruiseReizen.nl</b>  Zie je een promotie er tussen staan bijvoorbeeld inclusief een drankenpakket? Vaak is het een stuk voordeliger om direct voor dit tarief te kiezen inclusief de gewenste extra's in plaats van achteraf de pakketten apart bij te boeken! Vaak is het ook niet meer mogelijk om na boeking, het gekozen tarief alsnog om te zetten.</p>  </div>
                          <div style="padding-block:10px;" class="midblock hoverme floatleft relative width100 marginbottom15 " v-for="(rate,
                                            key) in availableRates"
                               :key="'AvailableRatesSelect' + key"
                               v-on:click="payload.rateCode = key; resetCabinConfig(4)">

                            <div class="padding15 textleft dim" v-bind:id="key">
                              <div
                                  class="floatleft" style="display: flex;
    justify-content: space-between;
    width: 100%;
flex-wrap: wrap"
                              >
                                <div style="padding-left:5px;width: calc(100% - 355px);min-width:300px;" class="mobile-mb">
                                  <b style="font-size:14px;"> {{
                                      findRateNameByKey(key).rateName
                                    }}</b>
<div style="display:flex;flex-flow:row;margin-top:5px;flex-wrap:wrap;">

  <div
      v-for="(usps, index) in rateCodesByRate(key)"
      :key="'MatchingRateCodes' + index"
      :class="{ pointer: usps.detail !== '' }"
      class="mobile-100"
      style="display:flex;padding-right:20px;width:50%;box-sizing: border-box"
  >

    <div>
      <font-awesome-icon
          :icon="validateIcon(usps.icon)"
          :class="usps.color"
      />
    </div>
    <div style="padding-left:5px;position:relative">
      {{ usps.text }}
      <font-awesome-icon
          v-if="usps.detail && usps.detail !== ''"
          icon="info"
          class="darkblue font10"
          style="vertical-align:  text-top;"
          v-on:mouseenter="usps.showDetail = true"
          v-on:mouseleave="usps.showDetail = false"
      />
      <div
          v-if="usps.showDetail"
          v-html="usps.detail"

          style="line-height: 13px;position:fixed; width:50%;background:#fff; border-radius:5px;padding-block:8px; padding-inline:4px;z-index:10;border:1px solid #d5d2d2"
      ></div>


    </div>

  </div>
    <div v-if="euroaanbetaling && !isRateFullPay(key)" style="margin-top:5px; color: green; font-weight: bold; width:100%;">
        Boek nu met  &euro; 1,- aanbetaling!
    </div>
</div>
                                </div>
                                <div class="pricecentermobile" v-if="findRateNameByKey(key).lowestForRate && findRateNameByKey(key).lowestForRate[payload.cabins[0].cabinType.toLowerCase()]" style=" width: 150px;
color: rgb(33, 120, 179);
    display: flex;
    flex-flow: column;
    justify-content: center;">
                                          <span >
                                    vanaf <b style="font-size:14px;">&euro; {{ roundPrice(parseInt(findRateNameByKey(key).lowestForRate[payload.cabins[0].cabinType.toLowerCase()])) }}</b>*
                                  </span>

                                </div>

                                  <div>
                                      <button style="height:38px;width:200px;"
                                              type="button"
                                              v-on:click="payload.rateCode = key; resetCabinConfig(4)"
                                              class="btn btn-success btn-addon width100 font14 bold floatleft"
                                      >
                                          Selecteer <font-awesome-icon icon="angle-right" />

                                      </button>
                                      <div v-if="euroaanbetaling  && !isRateFullPay(key)" style="margin-top:5px; color: green; font-weight: bold">
                                          <img src="https://cdn.cruisereizen.nl/tijdelijk.png" style="width:80px;margin:auto; margin-top:50px;">

                                      </div>
                                  </div>

                              </div>
                              <div class="clearfix"></div>
                            </div>
                          </div>
                          <div style="color: #7f8386!important; width:100%;float:left">
                            * Deze prijzen zijn indicatief, op basis van een reisgezelschap van twee personen en worden in de volgende stap gecontroleerd. Het kan zijn dat hier een prijswijziging zal plaatsvinden.
                          </div>
                        </div>
                      <div v-else-if="availabilityReceived &&
                                    availableRates &&
                                    Object.keys(availableRates).length === 0 &&
                                    ajaxCalls === 0" class="midblock floatleft relative width100" v-on:click="setActiveStep(4)">
                        <div class="padding15 textleft">
                          <div
                              class="floatleft" style="margin-top:10px;"
                          >
                            Er zijn geen actietarieven. Wij kiezen automatisch de beste prijs van de dag. Ga door naar stap 4.
                          </div>
                          <button
                              type="button"
                              id="teststap2wijzigen"
                              class="btn btn-success btn-addon font14 bold floatright editbutton"
                          >
                            Ga door <font-awesome-icon icon="angle-right" />
                          </button>
                          <div class="clearfix"></div>
                        </div>
                      </div>
                      <div v-else class="midblock floatleft relative width100">
                        <div class="padding15 textleft dim">
                          <div
                              class="floatleft"
                          >
                            Bezig met ophalen  <font-awesome-icon
                              icon="spinner"
                              :spin="true"
                          />
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      </div>
                    </div>
                  <div v-else-if="payload.rateCode && activeStep > 3" class="midblock floatleft relative width100">
                    <div class="padding15 textleft dim">
                      <div class="floatleft margintop10">
                        Geselecteerde actie:
                        <b>   {{
                            findRateNameByKey(payload.rateCode).rateName
                          }}</b>
                      </div>
                      <button
                          v-on:click="setPeopleAndStep(3)"
                          type="button"
                          id="teststap2wijzigen"
                          class="btn btn-success btn-addon font14 bold floatright editbutton"
                      >
                        Wijzigen
                      </button>

                      <div class="clearfix"></div>
                    </div>
                  </div>


                  </div>
                  <div class="booksteps"  v-show="activeStep === 4 || activeStep === 5">
                    <NumberHeader
                        v-on:click.native="setPeopleAndStep(4)"
                        :number="4"
                        :activeStep="activeStep"
                        :loading="!availabilityReceived"
                        :title="'Kies je hut'"
                        :subtitle="
                            'Wij hebben alvast de meest voordelige ' +
                                payload.cabins[0].cabinType.toLowerCase() +
                                ' voor je gesorteerd. Je kan ook kiezen voor een ander type ' +
                                payload.cabins[0].cabinType.toLowerCase()+ '. Houd er rekening mee dat de informatie op onze website kan wijzigen. De afbeelding is een indicatie van de gekozen hutcategorie. De indeling, meubilair en grootte kan in werkelijkheid afwijken. Hier kunnen geen rechten aan worden ontleend.'
                        "
                    />


                    <div
                        v-if="activeStep === 4 || activeStep === 5"
                        :class="{
                            hide: activeStep !== 4 && activeStep !== 5,
                            show: activeStep === 4 || activeStep === 5,
                        }"
                    >

                        <div class="cabin-wrapper">
                            <div
                                class="cabin-container cabin-container-vertical"
                                id="cabin-detail-select"
                                v-on:scroll="
                                    scrollElement('#cabin-detail-select', false)
                                "
                            >

                              <div v-if="!availabilityReceived || !availableRates || ajaxCalls !== 0" style="position:relative">

                                    <div>
                                      <div class="item loadingbg">
                                        <div class="dim">
                                          <div class="flexcabin midblock hoverme" style="position: relative;">
                                            <div style="width: 20%; overflow-y: hidden;">

                                              <div class="cabin_section">
                                                <div class="cabin_images width100 fakebox" style="position: relative;">
                                                  <div
                                                      class="width100 cabin-image resize-image"></div></div>
                                              </div>
                                            </div>
                                            <div class="flexmobile-wrap"
                                                 style="width: 40%; padding-left: 10px; display: flex;">
                                              <div
                                                  style="width: 50%; font-size: 16px; padding-top: 20px; max-height: initial;">
                                                <b>Laat ons de binnenhut kiezen</b><br><span style="font-size: 12px;"> We zullen de meest voordelige en best beschikbare binnenhut kiezen. Zo hoef je zelf niet na te denken over de ligging en locatie. </span>
                                              </div>

                                            </div>
                                            <div style="width: 40%; display: flex;">
                                              <div
                                                  style="width: 50%; display: flex; flex-flow: column; justify-content: center;">
                                                  <span><h2 class="darkblue bold"
                                                            style="font-weight: normal; font-size: 16px; text-align: center !important; width: 100%;"> € 749,- <small>p.p.</small></h2></span>
                                              </div>
                                              <div
                                                  style="width: 50%; display: flex; flex-flow: column; justify-content: center;">
                                                <div style="width: 90%; margin-top: -10px;">
                                                  <button type="button" id="testCabinSelect0"
                                                          class="btn btn-success btn-addon width100 font14 bold uppercase floatleft margintop10">
                                                    Selecteer
                                                  </button>
                                                  <br></div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="fakebox"
                                              style="width: 100%; margin-top: 30px; margin-bottom: 20px; text-align: center; font-size: 16px; background-image: linear-gradient(transparent, transparent 49%, black 49%, transparent 53%);">

                                          </div>
                                        </div>
                                      </div><!---->
                                      <div class="item loadingbg" v-for="x in [1,2]">
                                        <div class="flexcabin midblock hoverme dim"
                                             style="margin-top: 10px; margin-bottom: 0px;">
                                          <div style="width: 20%; overflow-y: hidden;">

                                            <div class="cabin_section">
                                              <div class="cabin_images width100 fakebox" style="position: relative;">
                                                <div
                                                    class="width100 cabin-image resize-image"></div></div>
                                            </div>
                                          </div>
                                          <div class="flexmobile-wrap"
                                               style="width: 80%; padding-left: 10px; display: flex;">
                                            <div style="width: 50%; font-size: 16px; padding-top: 20px;"><b>Binnenhut
                                              Deluxe (Regular) IR1</b><br><!----><!----><span
                                                style="font-size: 11px; color: rgb(129, 133, 136);"><svg
                                                aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user"
                                                role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
                                                class="svg-inline--fa fa-user fa-w-14"><path fill="currentColor"
                                                                                             d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                                                                                             class=""></path></svg> Max 4 pers. </span>
                                              <!----><!----></div>
                                            <div style="width: 50%; display: flex;">
                                              <div
                                                  style="width: 50%; display: flex; flex-flow: column; justify-content: center;">
                                                <span><h2 class="darkblue bold"
                                                          style="font-weight: normal; font-size: 16px; text-align: center !important; width: 100%;"> € 749,- <small>p.p.</small></h2></span>
                                              </div>
                                              <div
                                                  style="width: 50%; display: flex; flex-flow: column; justify-content: center;">
                                                <div style="width: 90%; margin-top: -10px;">
                                                  <button type="button" id="testCabinSelect0"
                                                          class="btn btn-success btn-addon width100 font14 bold uppercase floatleft margintop10">
                                                    Selecteer
                                                  </button>
                                                  <br></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="hide">
                                          <div class="midblock floatleft relative width100" payload="[object Object]"
                                               ajaxcalls="0">
                                            <div class="padding20 textleft">
                                              <center>
                                                <svg aria-hidden="true" focusable="false" data-prefix="fas"
                                                     data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 512 512"
                                                     class="svg-inline--fa fa-spinner fa-w-16 fa-spin">
                                                  <path fill="currentColor"
                                                        d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                                                        class=""></path>
                                                </svg>
                                                Bezig met ophalen van hutnummers...
                                              </center>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                    </div>

                                <StepLoading  v-if="!availabilityReceived || !availableRates || ajaxCalls !== 0" />
                              </div>
                              <div v-else style="position: relative">
                                <div class="item" v-if="availableCabins && availableCabins[0] && availableCabins.length > 1">
                                  <CheapestCabinAvailabilityResult

                                      :cabin="availableCabins[0]"
                                      :index="0"
                                      :deckNames="deckNames"
                                      :payload="payload"
                                      :cruise="cruise"
                                      :isSelected="
                                            cabins.selected.code === availableCabins[0].code
                                        "
                                      :availabilityReceived="
                                            availabilityReceived
                                        "
                                      :class="{
                                            dim: true,
                                        }"
                                      :numberWithCommas="numberWithCommas"
                                      :roundPrice="roundPrice"
                                      :cabinName="cabinName"
                                      :findRateName="findRateName"
                                      v-on:selectCabin-click="
                                            confirmCabinCheapest(availableCabins[0])
                                        "
                                  />
                                </div>

                                <div v-if="cruise.rederij_id === '25' || cruise.rederij_id === '14'" class="notification-cabin">
                                  <p><b>Tip vanuit CruiseReizen.nl</b>  De onderstaande hutten kunnen qua formaat en indeling gelijk zijn aan elkaar.
                                    De meerprijs heeft te maken met de ligging.
                                    Zo kunnen hoger gelegen hutten en centraal gelegen hutten wat hoger in prijs zijn.
                                    Je kunt in de volgende stap de ligging en het hutnummer ook bekijken en wijzigen.</p>
                                </div>
                                <div
                                    class="item"
                                    v-for="(cabin, index) in availableCabins"
                                    :key="'AvailableCabins' + index"
                                    :class="{
                                            selectedCabin: cabins.selected.code === cabin.code && activeStep === 5,
                                        }"
                                >
                                  <CabinAvailabilityResult
                                      :cabin="cabin"
                                      :index="index"
                                      :deckNames="deckNames"
                                      :payload="payload"
                                      :cruise="cruise"
                                      :activeStep="activeStep"
                                      :isSelected="
                                            cabins.selected.code === cabin.code
                                        "
                                      :availabilityReceived="
                                            availabilityReceived
                                        "
                                      :class="{
                                            dim: true,
                                            selectedCabin: cabins.selected.code === cabin.code && activeStep === 5,
                                        }"
                                      :numberWithCommas="numberWithCommas"
                                      :roundPrice="roundPrice"
                                      :cabinName="cabinName"
                                      :findRateName="findRateName"
                                      v-on:selectCabin-click="
                                            confirmCabin(cabin)
                                        "
                                  />
                                  <div v-if="cabins.selected.code === cabin.code"
                                      :class="{
                            hide: activeStep !== 5,
                            show: activeStep === 5,
                        }"
                                  >
                                    <CabinNumberSelect
                                        :cabinNumbers="cabinNumbers"
                                        :cruise="cruise"
                                        :cabin="cabins.selected"
                                        :deckMapReceived="deckMapReceived"
                                        :toggleDeckMap="toggleDeckMap"
                                        :cabinName="cabinName"
                                        :displayCabinNumber="displayCabinNumber"
                                        :isGuaranteeCabin="isGuaranteeCabin"
                                        :payload="payload"
                                        :ajaxCalls="ajaxCalls"
                                        :showDeckMap="showDeckMap"
                                        :deckMap="deckMap"
                                        v-on:cabinNumberSelect-click="
                                skipFlightsIfneeded(6)
                            "
                                        v-on:getDeckMap-click="getDeckMap"
                                    />
                                  </div>
                                </div>

                              </div>

                                <div
                                    v-if="
                                        Object.keys(availableCabins).length ===
                                            0
                                    "
                                    class="midblock floatleft relative width100"
                                >
                                    <div class="padding15 textleft dim">
                                        <div class="floatleft margintop10">
                                            Er is geen
                                            {{
                                                payload.cabins[0].cabinType.toLowerCase()
                                            }}
                                            beschikbaar, kies een andere hut
                                            <span
                                                v-if="
                                                    availableRates &&
                                                        Object.keys(
                                                            availableRates
                                                        ).length > 1
                                                "
                                                >of tarief</span
                                            >...
                                        </div>

                                        <button
                                            v-on:click="setPeopleAndStep(2)"
                                            type="button"
                                            class="btn btn-success btn-addon font14 bold floatright"
                                        >
                                            Kies een andere type hut
                                        </button>

                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                  <div class="booksteps"  v-show="activeStep === 6 || activeStep === 7">
                    <NumberHeader
                        v-on:click.native="setPeopleAndStep(6)"
                        :number="6"
                        :activeStep="activeStep"
                        :loading="
                            !flightsReceived &&
                                !cruise.isLocalDeparture &&
                                !flightsTooFarFuture
                        "
                        :title="'Kies je extra\'s'"
                    />

                    <DinerSettings
                        v-if="activeStep == 6 || activeStep == 7"
                      :dinings="dinings"
                      :diningsRecieved="diningsRecieved"
                    />

                    <div class="font16 marginbottom20 pointer numberHeaderContainer darkblue" v-if="!cruise.isLocalDeparture"
                         style="line-height: 18px; margin-right: 12px; display: flex; flex-flow: column; width: 100%; padding-top: 20px">
                      <div  class="numberHeaderSubtitle darkblue"><b>Kies de vluchten </b>
                      </div>

                    </div>
                    <div
                        :class="{
                            hide: activeStep !== 6 && activeStep !== 7,
                            show: activeStep === 6 || activeStep === 7,
                        }"
                    >

                      <FlightSearch
                            :flights="flights"
                            :flightsReceived="flightsReceived"
                            :cruiseIsLocalDeparture="cruise.isLocalDeparture"
                            :flightsTooFarFuture="flightsTooFarFuture"
                            :flightPrice="flightPrice"
                            :totalPax="totalPax"
                            :aantalVolw="
                                parseInt(payload.cabins[0].volwassenen)
                            "
                            :cruise="cruise"
                            :payload="payload"
                            v-on:flights-search-click="getFlights"
                            v-on:flights-selected-click="setSteps(7, 7)"
                        />
                    </div>



                    <div class="font16 marginbottom20 pointer numberHeaderContainer darkblue"
                         style="line-height: 18px; margin-right: 12px; display: flex; flex-flow: column;padding-top:20px;width:100%;">
                      <div  class="numberHeaderSubtitle darkblue"><b>Kies de transfers </b>
                      </div>
                    </div>
                    <div
                        :class="{
                            hide: activeStep !== 6 && activeStep !== 7,
                            show: activeStep === 6 || activeStep === 7,
                        }"
                    >

                        <Transfers
                            v-if="cruise"
                            :cruise="cruise"
                            :flights="flights"
                            :totalPax="totalPax"
                            :transfers="transfers"
                            :outboundTransferPrice="outboundTransferPrice"
                            :inboundTransferPrice="inboundTransferPrice"
                            v-on:transfer-selected-click="setSteps(7, 7)"
                        />
                    </div>

                    <div
                        v-if="!cruise.isLocalDeparture"
                        class="paddingbottom30"
                    ></div>
                </div>
                  <div class="booksteps" v-show="activeStep === 8">
                    <NumberHeader
                        v-on:click.native="setPeopleAndStep(8)"
                        :number="modifierAfterFlights(8)"
                        :activeStep="activeStep"
                        :title="'Gegevens van het reisgezelschap'"
                        :subtitle="
                            'Om de gehele reis voor je in te boeken, hebben wij een aantal gegevens volgens paspoort nodig.'
                        "
                    />

                    <div
                        class="paxinfoBox"
                        :class="{
                            hide: activeStep !== 8,
                            show: activeStep === 8,
                        }"
                    >
                        <!--                                 @todo error below ?-->
                        <PaxInfo
                            v-if="paxInfoReceived"
                            :paxInfo="paxInfo"
                            :nationalities="nationalities"
                            :countries="countries"
                            :cruise="cruise"
                            :flightPrice="flightPrice"
                            :roundPrice="roundPrice"
                            :offerReceived="offerReceived"
                            :dossiernummer="dossiernummer"
                            :discount="discount"
                            :payment="createPayment"
                            v-on:paxinfo-valid-click="setSteps(9, 9)"
                            v-on:createOffer-click="createOffer"
                            v-on:getDiscount-click="getDiscount"
                        />
                    </div>

                    <div
                        v-if="
                            activeStep !== 8 &&
                                highestStep >= 8 &&
                                !peopleChanged
                        "
                        class="midblock floatleft relative width100"
                    >
                        <div class="padding15 textleft dim">
                            <div class="floatleft margintop10">
                                Het gezelschap bestaat uit:
                                <span class="bold">
                                    {{ paxInfoToNameArray(paxInfo) }}.
                                </span>
                            </div>

                            <button
                                v-on:click="setPeopleAndStep(7)"
                                type="button"
                                class="btn btn-success btn-addon font14 bold floatright editbutton"
                            >
                                Wijzigen
                            </button>

                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="paddingbottom30"></div>
                  </div>
                  <div class="booksteps"  v-show="activeStep === 9">
                    <div v-if="cruise.searchFlights || true">
                        <NumberHeader
                            v-on:click.native="setPeopleAndStep(9)"
                            :number="modifierAfterFlights(9)"
                            :activeStep="activeStep"
                            :title="'Betalen en bevestigen'"
                            :subtitle="
                                'We willen je boeking bijna bevestigen! De (aan)betaling kan je voldoen met iDeal, CreditCard of Mister Cash.'
                            "
                        />
                        <div
                            :class="{
                                hide: activeStep !== 9,
                                show: activeStep === 9,
                            }"
                        >
                          <div class="booksteps"  v-show="activeStep === 9">
                            <div class="midblock floatleft2 relative width100">
                              <Boekingsoverzicht
                                  v-if="paxInfo.collection"
                                  :passengers="paxInfo.collection"
                                  :nationalities="nationalities"
                                  v-on:toPreviousStep="setActiveStep(activeStep - 1)"
                              />
                              <PaymentInfo
                                  :payment="createPayment"
                                  :cruise="cruise"
                                  :waiting="waiting"
                                  :nrf="nrf"
                                  v-on:createReservation-click="createReservation"
                              />
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="paddingbottom30"></div>


                    <div v-if="!cruise.searchFlights && false">
                        <NumberHeader
                            :final="true"
                            :activeStep="activeStep"
                            :title="
                                'Je vrijblijvende reservering is aangevraagd!'
                            "
                            :subtitle="
                                'Jouw werk zit er op, wij lopen de aangevraagde onderdelen na op beschikbaarheid en sturen je spoedig de boekingsmogelijkheden.'
                            "
                        />
                    </div>



                    <div class="padding15">
                        <p style="text-align: center">
                            <small>
                                Standaard op basis van volpension tenzij anders
                                aangegeven, daarnaast zijn belastingen en
                                havengelden altijd inbegrepen in de getoonde
                                prijs. Tenzij anders aangegeven, zijn de prijzen
                                standaard exclusief vlucht(en), transfer(s) en
                                fooien. Alle vluchten zijn op basis van
                                handbagage, ruimbagage is optioneel bij te
                                boeken.
                            </small>
                        </p>
                    </div>


                </div>
                  <div class="paddingbottom30"></div>
                  <div style="display: flex; flex-flow:row;justify-content: space-between">
                    <div v-if="activeStep !== 1" style="cursor:pointer;line-height: 40px;padding-left:10px;">

                      <b v-on:click="activeStep--">

                        <font-awesome-icon icon="arrow-left" />
                        Ga terug naar de vorige stap</b>
                    </div>

                    <div
                        :class="{
                            hide: activeStep !== 6 && activeStep !== 7,
                            show: activeStep === 6 || activeStep === 7,
                        }"
                        v-on:click="activeStep = 8"
                        style="float:right"
                    >
                      <button
                          class="btn btn-success btn-addon font14 bold"

                      >
                        Ga door <font-awesome-icon icon="angle-right" />
                      </button>
                    </div>
                  </div>

                  <div class="paddingbottom30"></div>
                </div>

                <div class="sidebar floatright paddingbottom20" style="position: sticky;top: 20px;">
                    <SideBar
                        v-if="availabilityReceived"
                        :cruise="cruise"
                        :payload="payload"
                        :cabin="cabins.selected"
                        :cabinNumbers="cabinNumbers"
                        :paxInfo="paxInfo"
                        :flights="flights"
                        :numberWithCommas="numberWithCommas"
                        :roundPrice="roundPrice"
                        :isGuaranteeCabin="isGuaranteeCabin"
                        :payment="createPayment"
                        :flightPrice="flightPrice"
                        :totalPax="totalPax"
                        :cabinPrice="cabinPrice"
                        :totalPrice="totalPrice"
                        :feePrice="feePrice"
                        :dinings="dinings"
                        :diningsRecieved="diningsRecieved"
                        :sgrCalFondsPrice="sgrCalFondsPrice"
                        :displayCabinNumber="displayCabinNumber"
                        :lowestRateForCabinType="lowestRateForCabinType"
                        :cabinName="cabinName"
                        :availabilityReceived="availabilityReceived"
                        :transfers="transfers"
                        :discount="discount"
                        :transferPrice="transferPrice"
                        :euroaanbetaling="euroaanbetaling"
                        :discountaction="discountaction"
                        :euroaanbetalingsbedrag="euroaanbetalingsbedrag"
                        :campaignaction="campaignaction"
                        :coronaactie="coronaactie"
                        :showPrice="showPrice"
                        :activeTotalDiscount="activeTotalDiscount"
                        :activeFlightDiscount="activeFlightDiscount"
                        :activeTransferDiscount="activeTransferDiscount"
                        :class="{
                            blinky: blinkyBlink,
                        }"
                    />
                  <SideBarLoading v-else-if="!availabilityReceived"/>
                </div>
              </div>
                <div class="clearfix"></div>
            </div>

            <div class="clearfix"></div>
        </div>

        <Footer />

        <div class="deckmapoverlay" id="deckmapview">
            <DeckMapView
                v-show="showDeckMap"
                :toggleDeckMap="toggleDeckMap"
                :cabinNumbers="cabinNumbers"
                :deckMap="deckMap"
                v-on:getDeckMap-click="getDeckMap"
                :deckMapReceived="deckMapReceived"
                :showDeckMap="showDeckMap"
            />
        </div>

        <ViewerNotice v-if="!error" />

        <input
            id="testStarterPackRecieved"
            type="hidden"
            :value="starterPackReceived"
        />
        <input id="testErrorState" type="hidden" :value="response.error" />
        <input id="testErrorValue" type="hidden" :value="response" />

        <div v-if="error" class="errorMessage">
            <strong>
                <font-awesome-icon icon="bug" />
                Oeps,</strong
            >
            er is iets mis gegaan.<br />
            Vraag een offerte aan of neem contact op met onze klanten service
            via
            <a href="tel:0107200500">010 7200500</a>, wij helpen je graag
            verder.
            <br />
            <a
                v-if="payload && payload.cruiseID"
                :href="'/cruise/' + payload.cruiseID"
                class="btn btn-fail btn-addon font14 bold uppercase margintop20"
            >
                Keer terug naar de vorige pagina
            </a>
            <a
                v-else=""
                :href="'/'"
                class="btn btn-fail btn-addon font14 bold uppercase margintop20"
            >
                Keer terug naar de hoofdpagina
            </a>
        </div>
        <div v-if="false && availabilityReceived && cabinsAvailableWithPricing.length === 0" class="errorMessage">
            <strong>
                <font-awesome-icon icon="bug" />
                Oeps,</strong
            >
          Helaas, deze cruise heeft geen beschikbare hutten of geen hutten voor uw reisgezelschap.
          Neem contact op met onze klantenservice via <a href="tel:0107200500">010 720 0500</a> voor meer hulp, of bekijk onze andere cruises.

          <a
                v-if="payload && payload.cruiseID"
                :href="'/cruise/' + payload.cruiseID"
                class="btn btn-fail btn-addon font14 bold uppercase margintop20"
            >
                Keer terug naar de vorige pagina
            </a>
            <a
                v-else=""
                :href="'/'"
                class="btn btn-fail btn-addon font14 bold uppercase margintop20"
            >
                Keer terug naar de hoofdpagina
            </a>
        </div>
      <div v-if="error && this.$route.params.rate">
       {{ this.$route.params.id }}
        <meta http-equiv="refresh" v-bind:content="'0; url=\'/onlineboeken/' +  this.$route.params.id + '\''" />
      </div>
    </div>
</template>

<script>
import Header from './components/Header.vue'
import CabinConfigStep from './components/CabinConfigStep'
import CabinTypeSelect from './components/CabinTypeSelect.vue'
import CabinNumberSelect from './components/CabinNumberSelect.vue'
import NumberHeader from './components/NumberHeader.vue'
import Footer from './components/Footer.vue'
import CabinAvailabilityResult from './components/CabinAvailabilityResult.vue'
import PaymentInfo from './components/PaymentInfo.vue'
import PaxInfo from './components/PaxInfo.vue'
import SideBar from './components/SideBar.vue'
import DeckMapView from './components/DeckMap.vue'
import FlightSearch from './components/FlightSearch.vue'
import Transfers from './components/Transfers.vue'
import ViewerNotice from './components/ViewerNotice.vue'
import CongratulationsBanner from './components/CongratulationsBanner'
import NumberHeaderSmall from './components/NumberHeaderSmall'
import CheapestCabinAvailabilityResult from './components/CheapestCabinAvailabilityResult'
import SideBarLoading from './components/SideBarLoading'
import StepLoading from './components/StepLoading'
import Boekingsoverzicht from './components/Boekingsoverzicht'
import DinerSettings from './components/DinerSettings.vue'


export default {
    name: 'boeken',
    metainfo: {
        meta: [
            {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1, minimum-scale=1',
            },
        ],
    },
    components: {
      DinerSettings,
      StepLoading,

      SideBarLoading,
      CheapestCabinAvailabilityResult,
      NumberHeaderSmall,
        CongratulationsBanner,
        CabinConfigStep,
        CabinTypeSelect,
        Header,
        NumberHeader,
        CabinNumberSelect,
        Footer,
        PaxInfo,
        PaymentInfo,
        CabinAvailabilityResult,
        SideBar,
        DeckMapView,
        FlightSearch,
        Transfers,
        ViewerNotice,
        Boekingsoverzicht,
    },
    data: function() {
        return {
            payload: {
                cabins: [
                    {
                        volwassenen: 2,
                        kinderen: 0,
                        baby: 0,
                        jeugd: 0,
                        cabinCode: null,
                        cabinType: 'Binnenhut',
                        birthdates: {
                          volwassenen: ['1990-01-01', '1990-01-01'],
                          kinderen: [],
                          baby: [],
                          jeugd: []
                        }
                    },
                ],
                mode: null,
                flightDepartFrom: 'AMS',
                fooien_requested: false, //pick prijs with fooien or not
                fooien_amount: 0
            },
            showHiddenRates: false,
            firstLoad: 0,
            cruise: null,
            cabinTypes: null,
            paxTypes: null,
            cabins: null,
            cabinNumbers: null,
            deckMap: null,
            showDeckMap: false,
            buckParams: null,
            paxInfo: null,
            nationalities: null,
            deckNames: null,
            offerResult: null,
            dossiernummer: null,
            availableRates: Array, // contains available api specific rate codes

            starterPackReceived: false,
            availabilityReceived: false,
            cabinNumbersReceived: false,
            deckMapReceived: false,
            flightsReceived: false,
            flights: null,
            dinings: null,
            diningsRecieved: false,
            paxInfoReceived: false,
            reservationRecieved: false,
            offerReceived: false,
            betaalmethode: Number,
            bank: String,

            peopleChanged: false,

            activeStep: 2, // current step
            highestStep: 3, // highest step reached in session
            waiting: false, // active when calling specific blocking api calls
            ajaxCalls: 0, // amount of active calls awaiting

            transfers: {
                inboundTransfer: false,
                outboundTransfer: false,
                inboundId: null,
                outboundId: null,
                opAanvraag: false,
                totalPrice: 0,
            },
            discount: {
                level: null,
                name: null,
                color: null,
                img_url: null,
                starIcon: null,
                transferKorting: null,
                transferDiscount: null,
                vluchtKorting: null,
                flightDiscount: null,
                totaalKorting: null,
                totalDiscount: null,
                discountCode: null,
                retrieved: false,
            },
            lastUnsetRateCode: null,
            ipAccess: false,
            euroaanbetaling: false,
          euroaanbetalingPossible: false,
          euroaanbetalingMax: false,
          discountaction: false,
            discountactiontext: false,
            discountactiontitle: false,
            campaignaction: false,
            euroaanbetalingsbedrag: 1,

            coronaactie: false,
            showPrice: false,
          blinkyBlink: false,
        }
    },

    computed: {
        // ==============
        // Transfers
        // ==============
        // calculate and return Transfer Price
        feePrice: function() {
          if(this.cabins.selected.apiData !== undefined) {
            return this.cabins.selected.apiData.fooiprijs !== undefined ? parseInt(this.cabins.selected.apiData.fooiprijs) : 0
          }
          return 0;

        },
        feeUsed: function() {
          return this.payload.fooien_requested == true
        },

        isOffice: function() {
          return this.ipAccess;
        },

        transferPrice: function() {
            let price = 0
            if (!this.paxInfoReceived) {
                return price
            }
            if (this.transfers.outboundTransfer) {
                price = this.outboundTransferPrice
            }
            if (this.transfers.inboundTransfer) {
                price += this.inboundTransferPrice
            }
            return price
        },
        // outbound transfer price
        outboundTransferPrice: function() {
            if (!this.cruise) return null
            let pprice = this.totalPax * this.cruise.outbound_transferprijs

            if (pprice > this.cruise.outbound_min_transferprijs) {
                return parseInt(pprice)
            } else {
                return parseInt(this.cruise.outbound_min_transferprijs)
            }
        },
        // get pax count from store
        getPaxcount: function() {
            return this.$store.getters.totalPaxCountDetailed
        },
        // get hut type from store
        getHutType: function() {
            return this.$store.state.highlightedRate
        },
        // inbound transfer price
        inboundTransferPrice: function() {
            if (!this.cruise) {
                return 0
            }
            if (this.totalPax <= 0) {
                return 0
            }
            let pprice = this.totalPax * this.cruise.inbound_transferprijs

            if (pprice > this.cruise.inbound_min_transferprijs) {
                return parseInt(pprice)
            } else {
                return parseInt(this.cruise.inbound_min_transferprijs)
            }
        },
        // current transfer discount ammount
        activeTransferDiscount: function() {
            if (this.transferPrice <= 0) {
                // no discount
                return 0
            } else if (this.discount.transferKorting > this.transferPrice) {
                // max discount
                return this.transferPrice
            } else {
                // if lower than korting, discount is price
                return this.discount.transferKorting
            }
        },

        // ==============
        // Flights
        // ==============
        flightPrice: function() {
            if (!this.flightsReceived || !this.flights) return 0

            if (
                (this.flights.selectedOutbound &&
                    this.flights.selectedOutbound.id) ||
                (this.flights.selectedInbound &&
                    this.flights.selectedInbound.id &&
                    this.flights.selectedGroup &&
                    this.flights.selectedGroup.Identifier &&
                    this.flights.selectedGroup.totalPrice > 0)
            ) {
                return parseFloat(this.flights.selectedGroup.totalPrice)
            }
            return 0
        },
        activeFlightDiscount: function() {
            if (this.flightPrice <= 0) {
                // no discount
                return 0
            } else if (this.discount.vluchtKorting > this.flightPrice) {
                // max discount
                return this.flightPrice
            } else {
                // if lower than korting, discount is price
                return this.discount.vluchtKorting
            }
        },

        // ==============
        // Total Price
        // ==============
        // calculate and return total Price
        totalPrice: function() {

            if (!this.cruise) return 0
            let price = this.cabinPrice

            if (price === 0) {
                return 0
            }

            price += this.transferPrice - this.activeTransferDiscount
            price += this.flightPrice - this.activeFlightDiscount
            price -= this.activeTotalDiscount

            if(new Date() >= new Date('2023-07-13') && parseInt(this.cruise.rederij_id) === 20) {
                price += this.feePrice
            }

            price += this.sgrCalFondsPrice;

            if(this.euroaanbetalingPossible && this.euroaanbetalingMax !== 0) {
              if (price > this.euroaanbetalingMax) {
                this.euroaanbetaling = false;
              } else {
                this.euroaanbetaling = true;
              }
            }

            if(this.diningsRecieved && this.dinings !== null){
              if(this.dinings.feesSelected){
                price += this.dinings.fees;
              }
            }

            return price
        },

        // Calculate and return cabinprice
        cabinPrice: function() {
            let price = 0
            if (
                this.cabins &&
                this.cabins.selected &&
                this.cabins.selected.apiData &&
                this.cabins.selected.apiData.prijs
            ) {
                price += parseInt(this.cabins.selected.apiData.prijs)
            }
            return price
        },
        // calculate and return payment object
        activeTotalDiscount: function() {

            if(this.discountaction && (parseInt(this.cruise.rederij_id) === 20 || parseInt(this.cruise.rederij_id) === 31) && this.cabinPrice > 1500 && this.cruise.duur >= 8) {
                return 100;
            } else if (this.cabinPrice <= 0 || this.flightPrice <= 0) {
                // no discount
                return 0
            } else if (this.discount.totaalKorting > this.cabinPrice) {
                // max discount
                return this.totalPrice
            }  else {
                // if lower than korting, discount is price
                return this.discount.totaalKorting
            }
        },
      nrf: function() {
          if(this.cabins.selected.apiData && this.cabins.selected.apiData.directPay ) {
            return true;
          }
        let date = this.moment.duration(
            this.moment(this.cruise.begindatum, 'YYYY-MM-DD').diff(
                this.moment('2022-11-01', 'YYYY-MM-DD')
            )
        )
        return date.asDays() < 0
      },
        createPayment: function() {
            let durationTillDeparture = this.moment.duration(
                this.moment(this.cruise.begindatum, 'YYYY-MM-DD').diff(
                    this.moment()
                )
            )
            let type = 'betaling'
            let remainDate = this.moment()
            let amount = Math.floor(this.cabinPrice)
            let remain = 0

            if (this.cabinPrice > 0) {
                if (
                    durationTillDeparture.asDays() >= 57 &&
                    !this.cabins.selected.apiData.directPay
                ) {
                    type = 'aanbetaling'
                    amount = Math.floor(this.cabinPrice * 0.3)
                    remain = this.cabinPrice - amount
                    remainDate = this.cruise.remainDate
                }
            }
            amount += this.sgrCalFondsPrice
            amount += this.transferPrice - this.activeTransferDiscount
            amount += this.flightPrice - this.activeFlightDiscount

            if(new Date() >= new Date('2023-07-13') && parseInt(this.cruise.rederij_id) === 20) {
                amount += this.feePrice
            }

            if(this.diningsRecieved && this.dinings !== null){
              if(this.dinings.feesSelected){
                amount += this.dinings.fees;
              }
            }

            amount -= this.activeTotalDiscount

            if (
              durationTillDeparture.asDays() >= 42 && this.cabinPrice &&
              !this.cabins.selected.apiData.directPay && this.euroaanbetaling && (this.transferPrice === 0 && this.flightPrice === 0) && this.cabinPrice <= 8000
           ) {

            remain += (amount - (this.euroaanbetalingsbedrag + this.sgrCalFondsPrice));
            amount = (this.euroaanbetalingsbedrag + this.sgrCalFondsPrice);
          }

            return {
                durationTillDeparture: durationTillDeparture,
                type: type,
                amount: amount,
                remain: remain,
                total: remain + amount,
                remainDate: remainDate,
            }
        },

        // return default price for calamiteitenfonds and SGR fonds
        sgrCalFondsPrice: function() {
            return (this.totalPaxNoBaby * 5) + 2.5
        },

        // ====================
        // Filters and Computed
        // ====================

        response: function() {
            return this.$store.state.response
        },
        error: function() {
            return this.$store.state.response.error
        },
        // returns total passenger count
        totalPaxNoBaby: function() {
          let pCount = 0
            if (this.payload.cabins[0].volwassenen !== null) {
              pCount += parseInt(this.payload.cabins[0].volwassenen)
            }

            if (this.payload.cabins[0].jeugd !== null) {
              pCount += parseInt(this.payload.cabins[0].jeugd)
            }

            if (this.payload.cabins[0].kinderen !== null) {
              pCount += parseInt(this.payload.cabins[0].kinderen)
            }

          return pCount
        },
        // returns total passenger count
        totalPax: function() {
            let pCount = 0
            if (this.paxInfo && this.paxInfo.collection) {
                pCount = this.paxInfo.collection.length
            } else if (this.payload && this.payload.cabins[0]) {
                if (this.payload.cabins[0].volwassenen !== null) {
                    pCount += parseInt(this.payload.cabins[0].volwassenen)
                }

                if (this.payload.cabins[0].jeugd !== null) {
                    pCount += parseInt(this.payload.cabins[0].jeugd)
                }

                if (this.payload.cabins[0].kinderen !== null) {
                    pCount += parseInt(this.payload.cabins[0].kinderen)
                }

                if (this.payload.cabins[0].baby !== null) {
                    pCount += parseInt(this.payload.cabins[0].baby)
                }
            }

            return pCount
        },
        minAdult: function() {
            return 1
        },
        // filter on cabin availability
        availableCabins() {
            let type = this.payload.cabins[0].cabinType
            let availRec = this.availabilityReceived
            let ajaxCalls = this.ajaxCalls
            let rt = this.cabins.collection.filter(function(element) {

                if (availRec && ajaxCalls === 0) {

                    return element.apiData.prijs > 0 && element.type === type
                }
                return element.type === type
            })

            if (rt.length > 0) {
                rt.map(cabin => {
                    if (
                        cabin.code == this.$route.params.hutCat &&
                        this.firstLoad < 3
                    ) {
                        this.selectCabin(cabin)
                        this.cabinNumbers = {}
                        this.getCabinNumbers()

                        //@TODO Ryan

                        this.firstLoad++
                    }
                })

                return rt.sort(function(a, b) {
                    return a.apiData.prijs - b.apiData.prijs
                })
            } else {
                return {}
            }
        },
        // string concat flightnumbers
        concatFlightNumbers: function() {
            let flightNums = ''
            let count = 0
            if (!this.flightsReceived || this.flights === undefined) {
                return flightNums
            }

            if (
                this.flights.selectedOutbound !== undefined &&
                this.flights.selectedOutbound.flightNumber !== undefined
            ) {
                flightNums = this.flights.selectedOutbound.flightNumber
                count++
            }

            if (
                this.flights.selectedInbound !== undefined &&
                this.flights.selectedInbound.flightNumber !== undefined
            ) {
                flightNums += ' ' + this.flights.selectedInbound.flightNumber
                count++
            }

            return { flightNumText: flightNums, count: count }
        },
        // flights are too far into the future
        flightsTooFarFuture: function() {
            return (
                this.moment(this.cruise.begindatum).diff(
                    this.moment(),
                    'days'
                ) > 356
            )
        },
    },
    methods: {
        // =======
        // Methods
        // =======

      rateCodesByRate(rate){
        if (
            this.cruise &&
            this.cruise.ratecode_usps &&
            this.cruise.ratecode_usps.rates
        ) {



          let rateCode = rate

          if(this.cruise.rederij_id === '25') {
            rateCode = rateCode.substring(rateCode.length - 3)
          }

          let found = this.cruise.ratecode_usps.rates.filter(function(
              usps
          ) {
            return (
                (usps.rateCode === rateCode) &&
                usps.text !== ''
            )
          })
          if (!found[0]) {
            return []
          }
          return found[0].uspsItems
        }
        return []
      },

      validateIcon: function(icon) {
        if (icon === '') {
          return 'check'
        }
        return icon
      },
        setSteps: function(activeStep, HighestStep) {
            this.activeStep = activeStep
            this.highestStep = HighestStep
            this.setBlinkyBlink();
        },
        toggleDeckMap: function() {
            this.showDeckMap = !this.showDeckMap

            let self = this

            $(function() {
                if (self.showDeckMap) {
                    $('#app').addClass('noscroll')
                } else $('#app').removeClass('noscroll')
            })
        },

      setPaxForVlad: function() {


        let self = this

        if(parseInt(self.cruise.rederij_id) !== 14) {
          return false
        }

        if (!self.paxInfo || !self.paxInfo.collection) return false

        let lastType = "";
        let myIndex = 0;

        self.paxInfo.collection.forEach(function(el, index){

          if(lastType !== el.paxType){
            myIndex = 0;
          }

          el.dag = parseInt(self.payload.cabins[0].birthdates[el.paxType][myIndex].split('-')[2])
          el.maand = parseInt(self.payload.cabins[0].birthdates[el.paxType][myIndex].split('-')[1])
          el.jaar = parseInt(self.payload.cabins[0].birthdates[el.paxType][myIndex].split('-')[0])

          lastType = el.paxType;
          myIndex++;
        });
      },
        // reload paxInfoPayload from storage and match pax types.
        updatePaxInfoFromStorage: function() {
            let self = this
            let paxInfoPayload
            if (!self.paxInfo || !self.paxInfo.collection) return false

            return false //just disable auto fill

            try {
                paxInfoPayload = JSON.parse(localStorage.paxInfoPayload)
            } catch (e) {
                return false
            }

            // loop through our (clean) collection
            paxInfoPayload.obj.collection.forEach(function(paxIn) {
                // loop through available storage data
                self.paxInfo.collection.some(function(paxForm) {
                    // if matched pax type and not fromStorage previously
                    if (
                        paxForm.paxType === paxIn.paxType &&
                        !paxForm.fromStorage
                    ) {
                        // save our loaded state
                        paxForm.fromStorage = true
                        // set our values if null
                        if (paxForm.voornaam === null)
                            paxForm.voornaam = paxIn.voornaam
                        if (paxForm.tussenvoegsel === null)
                            paxForm.tussenvoegsel = paxIn.tussenvoegsel
                        if (paxForm.achternaam === null)
                            paxForm.achternaam = paxIn.achternaam
                        if (paxForm.dag === null) paxForm.dag = paxIn.dag
                        if (paxForm.maand === null) paxForm.maand = paxIn.maand
                        if (paxForm.jaar === null) paxForm.jaar = paxIn.jaar
                        if (paxForm.geboortedatum === null)
                            paxForm.geboortedatum = paxIn.geboortedatum
                        if (paxForm.geslacht === null)
                            paxForm.geslacht = paxIn.geslacht
                        if (paxForm.nationaliteit === null)
                            paxForm.nationaliteit = paxIn.nationaliteit
                        if (paxForm.retentionNumber === null)
                            paxForm.retentionNumber = paxIn.retentionNumber
                        if (paxForm.telefoonnummer === null)
                            paxForm.telefoonnummer = paxIn.telefoonnummer
                        if (paxForm.emailadres === null)
                            paxForm.emailadres = paxIn.emailadres
                        if (paxForm.Discount === null) {
                            paxForm.Discount = paxIn.Discount
                            self.discount.number = paxIn.Discount
                        }
                        return true // we are done for this paxinfo onto next input from storage.
                    }
                })
            })
        },
        // Company as in People
        changeCompany: function() {
            this.resetCabinApiData()
            this.peopleChanged = true
        },  // Company as in People
        changeBirthdateCompany: function() {
            this.peopleChanged = true
        },

        // Reset Cabin Config
        toggleFee: function(toggle) {
          this.payload.fooien_requested = toggle
          this.resetCabinConfig()
        },

      toggleIPAccess: function() {
        this.showHiddenRates = !this.showHiddenRates
        this.resetCabinConfig();
      },
        // Reset Cabin Config
        resetCabinConfig: function(step = false) {
            if (this.waiting) return false

            this.payload.fooien_amount = this.cabins.selected.apiData !== undefined && this.cabins.selected.apiData.fooiprijs !== undefined  ? this.cabins.selected.apiData.fooiprijs : 0;

            this.availabilityReceived = false
            this.resetCabinApiData()

            this.cabinNumbersReceived = false
            this.cabinNumbers = {}

            this.deckMapReceived = false
            this.deckMap = null

            this.flightsReceived = false
            this.flights = null

            this.paxInfoReceived = false
            this.paxInfo = {}

            this.offerReceived = false

            // only increment if we are currently on step 1
            if (this.activeStep == 1) {
                this.setActiveStep(2)
            }



            this.getCabinAvailability()
          if(step) {
            this.setActiveStep(step);
          }
        },
        // resets each individual cabin apiData object
        resetCabinApiData: function() {
            if (Array.isArray(this.cabins.collection)) {
                this.cabins.collection.forEach(function(cabin) {
                    // reset apiData
                    cabin.apiData = false
                })
            }
          this.setBlinkyBlink();
        },

        // ==========
        // Ajax Calls
        // ==========
        // get starterPack
        getStarterPack: function() {
            let self = this
            let input = this.$route.params.id
            let routeCruiseID

            if (typeof input == 'number') {
                routeCruiseID = input
            } else {
                let pieces = input.split('-')

                routeCruiseID = parseInt(pieces.slice(-1)[0])
                if (!Number.isInteger(routeCruiseID)) {
                    this.$router.push({ name: 'NotFound' })
                    return
                }
            }

            // add payload mode string for testing/debug
            self.payload.mode = this.$route.params.mode

            // if route has id set, use id from vue router id param
            //let routeCruiseID = parseInt(this.$route.params.id);


            self.waiting = true
            self.payload.cruiseID = routeCruiseID
            self.payload.action = 'getStarterKit'
            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: self.payload,
                success: function(responseData) {
                    self.$store.dispatch('saveLog', responseData.response)
                    self.waiting = false
                    if (!self.error) {
                        self.payload = responseData.payload
                        self.cruise = responseData.cruise
                        self.cabinTypes = responseData.cabinTypes
                        self.cabins = responseData.cabins
                        self.paxTypes = responseData.paxTypes
                        self.cabinNumbers = responseData.cabinNumbers
                        self.paxInfo = responseData.paxInfo
                        self.nationalities = responseData.nationalities
                        self.countries = responseData.countries
                        self.deckNames = responseData.deckNames
                        self.ipAccess = responseData.ipAccess
                      self.euroaanbetaling = responseData.euroaanbetaling
                      self.euroaanbetalingPossible = responseData.euroaanbetaling
                      self.euroaanbetalingMax = responseData.euroaanbetalingMax
                      self.discountaction = responseData.discountaction
                      self.discountactiontitle = responseData.discountactiontitle
                      self.discountactiontext = responseData.discountactiontext
                      self.campaignaction = responseData.campaignaction
                      self.euroaanbetalingsbedrag = responseData.euroaanbetalingsbedrag
                      self.coronaactie = responseData.coronaactie
                        if (responseData.discount) {
                            self.discount = responseData.discount
                        }
                        self.starterPackReceived = true
                        self.getCabinAvailability()
                    }
                },
                error: function(error) {
                    self.waiting = false
                    self.$store.dispatch('saveLog', error)
                },
            })
        },
        // get cabin availability
        getCabinAvailability: function() {
            let self = this
            self.availabilityReceived = false
            self.paxInfoReceived = false
            self.waiting = true
            self.cabinNumbers = {}
            self.payload.action = 'getCabinAvailability'
            self.payload.showHiddenRates = this.showHiddenRates
            self.payload.activeStep = this.activeStep
            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: self.payload,
                success: function(responseData) {

                    self.$store.dispatch('saveLog', responseData.response)
                    if (!self.error) {
                        if (Array.isArray(responseData.apiData)) {
                            responseData.apiData.forEach(function(data) {
                                // loop through cabin collection
                                self.cabins.collection.forEach(function(cabin) {
                                    // find matching results

                                    if (cabin.code === data.code) {
                                        // inject apiData into matching cabin
                                        cabin.apiData = data
                                        self.payload.sailingID =
                                            cabin.apiData.sailingID
                                        self.payload.rateCode =
                                            cabin.apiData.rateCode
                                    }
                                })
                            })
                        }
                        // loop through cabin collection and if retrieve price do async ajax calls
                        self.cabins.collection.forEach(function(element) {
                            if (element.apiData.retrievePrice) {
                                self.ajaxCalls++
                                self.payload.action = 'getCabinPrice'
                                self.payload.cabinCode = element.code
                                self.payload.sailingID =
                                    element.apiData.sailingID
                                self.payload.rateCode = element.apiData.rateCode
                                $.ajax({
                                    url: '/paginas/boeken2/ajax.php',
                                    method: 'GET',
                                    data: self.payload,
                                    success: function(responseData) {
                                        self.ajaxCalls--
                                        self.$store.dispatch(
                                            'saveLog',
                                            responseData.response
                                        )
                                        if (!self.error) {
                                            // loop through collection to find cabin and set price
                                            self.cabins.collection.some(
                                                function(cabin) {
                                                    // find matching results
                                                    if (
                                                        responseData
                                                            .apiData[0] !== undefined &&
                                                        cabin.code ===
                                                            responseData
                                                                .apiData[0]
                                                                .code &&
                                                        cabin.apiData
                                                    ) {
                                                        // block updates
                                                        if (
                                                            cabin.apiData
                                                                .retrievePrice
                                                        ) {
                                                            cabin.apiData.retrievePrice = false
                                                        }
                                                        // update price

                                                        //cabin.apiData.prijs = responseData.apiData[0].prijs;
                                                        self.$set(
                                                            cabin.apiData,
                                                            'prijs',
                                                            responseData
                                                                .apiData[0]
                                                                .prijs
                                                        )
                                                        // break loop
                                                        return true
                                                    }
                                                }
                                            )
                                            if (self.ajaxCalls === 0) {
                                                self.selectCabin(
                                                    self.availableCabins[0]
                                                )
                                                self.availabilityReceived = true
                                            }
                                        }
                                    },
                                    error: function(error) {
                                        self.ajaxCalls--
                                        self.$store.dispatch('saveLog', error)
                                        self.waiting = false
                                    },
                                })
                            }
                        })

                        // if non local cruise and departure within limit start flight retrieval api call
                        if (
                            !self.cruise.isLocalDeparture &&
                            !self.flightsTooFarFuture
                        ) {
                            self.getFlights()
                            self.getTransfers()
                        }
                        // set our available rates if returned
                        self.availableRates = responseData.availableRates

                        if (
                            self.availableRates[self.payload.rateCode] ===
                            undefined
                        ) {
                            let newCode = Object.keys(self.availableRates)[0]
                            self.$store.dispatch('saveLog', {
                                error: false,
                                track: true,
                                messages: [
                                    'Rate not found: ' +
                                        self.payload.rateCode +
                                        ' defaulting to: ' +
                                        newCode,
                                ],
                            })
                            self.payload.rateCode = newCode
                        }

                        self.checkRates()

                        self.paxInfo = responseData.paxInfo
                        self.updatePaxInfoFromStorage()
                        self.setPaxForVlad()
                        self.paxInfoReceived = true
                        self.waiting = false
                        self.availabilityReceived = true

                        // finally set our default selection to lowest price
                        if (self.ajaxCalls === 0) {
                            self.selectCabin(self.availableCabins[0])
                        }
                    }
                },
                error: function(error) {
                    self.waiting = false
                    self.$store.dispatch('saveLog', error)
                    self.availabilityReceived = false
                },
            })
        },
        // retrieve cabin numbers availability from shipping company
        getCabinNumbers: function() {
            let self = this
            if (!self.availabilityReceived) return false
            self.cabinNumbers = {}
            self.deckMap = null
            self.cabinNumbersReceived = false
            self.deckMapReceived = false

            self.payload.cabinCode = self.cabins.selected.code
            self.payload.rateCode = self.cabins.selected.apiData.rateCode
            self.payload.planCode = self.cabins.selected.apiData.planCode
            self.payload.componentID = self.cabins.selected.apiData.componentID
            self.payload.packageCode = self.cabins.selected.apiData.packageCode
            self.payload.packageItemCode = self.cabins.selected.apiData.packageItemCode
            self.payload.sailingID = self.cabins.selected.apiData.sailingID
            self.payload.sessionID = self.cabins.selected.apiData.sessionID
          self.getAvailableDining();

          self.payload.action = 'getCabinNumbers'
          if (typeof self.cabins.selected.apiData.gradeNo !== 'undefined') {
              self.payload.gradeNo = self.cabins.selected.apiData.gradeNo
              self.payload.resultno = self.cabins.selected.apiData.resultno
              self.payload.sessionkey = self.cabins.selected.apiData.sessionkey
            }

            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: self.payload,
                success: function(responseData) {
                    self.$store.dispatch('saveLog', responseData.response)
                    self.waiting = false
                    if (!self.error) {
                        self.cabinNumbers = responseData.cabinNumbers
                        self.cabinNumbersReceived = true
                        self.payload.bedConfig = responseData.cabinNumbers.bedConfig ? responseData.cabinNumbers.bedConfig : ''
                        self.getDeckMap()
                    }
                },
                error: function(error) {
                    self.waiting = false
                    self.$store.dispatch('saveLog', error)
                    self.cabinNumbers = []
                    self.cabinNumbersReceived = false
                },
            })
        },
        // retrieve deckmap
        getDeckMap: function() {
            let self = this
            let cabinNumber = self.cabinNumbers.selected
            if (!self.cabinNumbersReceived) return false

            if (this.isGuaranteeCabin(cabinNumber)) {
                return false
            }
            self.deckMapReceived = false
            self.deckMap = 'change';

            self.payload.action = 'getDeckMap'
            self.payload.cabinNumber = cabinNumber
            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: self.payload,
                success: function(responseData) {
                    self.$store.dispatch('saveLog', responseData.response)
                    self.waiting = false
                    if (!self.error) {
                        if (responseData.deckMap.html !== '') {
                            self.deckMap = responseData.deckMap
                            self.deckMapReceived = true
                        } else {
                            self.$store.dispatch('saveLog', {
                                error: false,
                                messages: ['Got DeckMap without data'],
                            })
                        }
                    }
                },
                error: function(error) {
                    self.waiting = false
                    self.$store.dispatch('saveLog', error)
                    self.deckMapReceived = false
                    self.deckMap = null
                },
            })
        },
        // get Matching Flight results
        getFlights: function() {
            let self = this
            self.flightsReceived = false
            self.flights = {}
            self.payload.action = 'getFlights'
            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: self.payload,
                success: function(responseData) {
                    self.$store.dispatch('saveLog', responseData.response)
                    self.waiting = false
                    if (!self.error) {
                        self.flights = responseData.flights
                        self.flightsReceived = true
                    }
                },
                error: function(error) {
                    self.waiting = false
                    self.$store.dispatch('saveLog', error)
                },
            })
        },
        // get Matching Transfer results
        getTransfers: function() {
          let self = this
          self.payload.action = 'getTransfers'
          $.ajax({
            url: '/paginas/boeken2/ajax.php',
            method: 'GET',
            data: self.payload,
            success: function(responseData) {
              self.$store.dispatch('saveLog', responseData.response)
              self.waiting = false;
              if (!self.error) {
                self.cruise.outbound_transferprijs = responseData.transfers.outbound.price / self.totalPax;
                self.cruise.inbound_transferprijs = responseData.transfers.inbound.price / self.totalPax;

                self.transfers.inboundId = responseData.transfers.inbound.id;
                self.transfers.outboundId = responseData.transfers.outbound.id;
              }
            },
            error: function(error) {
              self.waiting = false
              self.$store.dispatch('saveLog', error)
            },
          })
        },
        // get Matching Flight results
        getAvailableDining: function() {
            let self = this;
            self.diningsRecieved = false;
            self.dinings = null;
            self.payload.action = 'getDiningInfo'
            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: self.payload,
                success: function(responseData) {
                  self.diningsRecieved = true;
                  let selected = 0;
                  let feesSelected = false;
                  if(responseData['response']['options'].length !== 0) {
                    feesSelected = responseData['response']['options'][0].Sitting === 'O';
                    selected = responseData['response']['options'][0].Sitting;
                  }

                  self.dinings = {
                    options: responseData['response']['options'],
                    selected: selected,
                    fees: responseData['response']['fees'],
                    feesSelected: feesSelected,
                  };
                },
                error: function(error) {
                    self.waiting = false
                    self.$store.dispatch('saveLog', error)
                },
            })
        },
        // handles Dossier creation and offloading to payment provider
        createReservation: function() {
            if (this.waiting) return false

            //if (this.buckParams) return false; // prevent multiple postbacks
            if (!this.snapShotDossierPayload()) return false
            this.waiting = true
            this.payload.action = 'createReservation'
            this.payload.totalDiscount = this.activeTotalDiscount

            if(this.dinings !== null) {
              if(this.dinings.selected === 'M') {
                this.payload.dinerzitting = 'main';
              }else if(this.dinings.selected === '2') {
                this.payload.dinerzitting = 'late';
              }else if(this.dinings.selected === 'O') {
                this.payload.dinerzitting = 'open';
              }
              this.payload.cabins[0].diningOption = this.dinings.selected;

              if(this.dinings.feesSelected){
                this.payload.fooien_requested = true;
                this.payload.fooien_amount = this.dinings.fees;
              }
            }else {
              this.payload.cabins[0].diningOption = null;
              this.payload.cabins[0].feesSelected = null;
            }

            let self = this
            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'POST',
                data: self.payload,
                success: function(responseData) {
                    self.$store.dispatch('saveLog', responseData.response)
                    if (!self.error) {
                        self.reservationRecieved = responseData.reservationState
                        self.dossiernummer = responseData.dossiernummer

                      self.sendDataLayer(self.payload, 'start_payment');

                      document.location = responseData.redirect_url
                          // console.log(responseData.redirect_url);
                        self.waiting = false
                    }
                },
                error: function(error) {
                    self.$store.dispatch('saveLog', error)
                    self.waiting = false
                },
            })
        },
        //  handles Offer Dossier creation
        createOffer: function() {
            if (this.waiting) return false
            this.snapShotDossierPayload()
            this.waiting = true
            this.payload.action = 'createOffer'

            let self = this
            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: self.payload,
                success: function(responseData) {
                    self.$store.dispatch('saveLog', responseData.response)
                    if (!self.error) {
                        self.offerReceived = responseData.offerState
                        self.dossiernummer = responseData.dossiernummer
                        self.waiting = false
                    }
                },
                error: function(error) {
                    self.$store.dispatch('saveLog', error)
                    self.waiting = false
                },
            })
        },
        // gets current cardlevel or discount
        getDiscount: function() {
            if (this.waiting) return false
            this.waiting = true
            this.payload.action = 'getDiscount'
            this.payload.cardNumber = this.discount.discountCode
            this.payload.cabinPrice = this.cabinPrice
            this.payload.flightPrice = this.flightPrice
            this.payload.transferPrice = this.transferPrice
            this.payload.totalPrice = this.totalPrice

            // save used cardnumber
            this.paxInfo.collection[0].Discount = this.payload.cardNumber

            let self = this
            $.ajax({
                url: '/paginas/boeken2/ajax.php',
                method: 'GET',
                data: self.payload,
                success: function(responseData) {
                    self.$store.dispatch('saveLog', responseData.response)
                    if (!self.error) {
                        self.discount = responseData.discount
                        self.waiting = false
                    }
                },
                error: function(error) {
                    self.$store.dispatch('saveLog', error)
                    self.waiting = false
                },
            })
        },
        // saves a snapshot of complete payload
        snapShotDossierPayload: function() {
            if (!this.availabilityReceived) return false
            if (!this.cabinNumbersReceived) return false
            if (!this.paxInfoReceived) return false
            let payment = this.createPayment
            if (payment.amount <= 0) return false

            this.payload.totalPrice = this.totalPrice
            this.payload.cabinPrice = this.cabinPrice
            this.payload.type = payment.type
            this.payload.amount = payment.amount
            this.payload.remain = payment.remain
            this.payload.remainDate = this.moment(payment.remainDate).format(
                'YYYY-MM-DD'
            )
            this.payload.cabinNumber = this.cabinNumbers.selected
            this.payload.fooiCode = this.cabins.selected.apiData.fooiCode
            this.payload.rateCode = this.cabins.selected.apiData.rateCode
            this.payload.sailingID = this.cabins.selected.apiData.sailingID
            this.payload.paxInfo = this.paxInfo
            this.payload.rederij_naam = this.cruise.rederij_naam
            this.payload.cruise = this.cruise
            this.payload.transfer = this.transfers

            this.payload.betaalmethode = $(
                "input[name='method']:checked"
            ).val()
            this.payload.bank = $(
                "select[name='bank[" + this.payload.betaalmethode + "]']"
            ).val()

            if (this.flights) {
                this.payload.airTradeSession = this.flights.airTradeSession
                this.payload.airTradeResult = this.flights.selectedGroup.resultListIdentifier
                this.payload.airTradeGroup = this.flights.selectedGroup.Identifier
                this.payload.flightInbound = this.flights.selectedInbound
                this.payload.flightOutbound = this.flights.selectedOutbound
                this.payload.flightOffer = this.flights.selectedFlightOffer
                this.payload.flightPrice = this.flights.totalPrice
            }

            return true
        },

        //  =========
        //  Functions
        //  =========
        // finds the lowest price for your cabin type: binnenhut/buitenhut
        lowestRateForCabinType: function(type) {
            let rt = this.cabins.collection
                .filter(function(element) {
                    if (element.apiData === false) return false
                    return element.type === type
                })
                .sort(function(a, b) {
                    return a.apiData.prijs - b.apiData.prijs
                })

            if (rt.length >= 0) {
                return rt[0]
            }
            // else return empty object
            return null
        },

      cabinsAvailableWithPricing: function() {
            return this.cabins.collection.filter(function(element) {
                    if (element.apiData === false) return true
                    if (element.apiData.prijs === 0) return false
                    return true;
                })



        },
        // seeks ratecode display name in rederij json data
        findRateName: function(rateName, rateCode) {

            let foundRate
            if (this.cruise.ratecode_usps.rates) {
                foundRate = this.cruise.ratecode_usps.rates.find(function(
                    element
                ) {
                    return (
                        element.rateCode === rateCode ||
                        element.rateCode === rateName
                    )
                })
            }

            if (typeof foundRate === 'undefined' || foundRate === null) {
                foundRate = { rateCode: rateCode, rateName: rateName }
            }
            return foundRate
        },
      findRateNameByKey: function(rateCode) {

            let foundRate

            var rateCodeNew = rateCode;
            if(this.cruise.rederij_id === '25') {
              rateCodeNew = rateCode.substring(rateCode.length - 3)
            }

            if (this.cruise.ratecode_usps.rates) {
                foundRate = this.cruise.ratecode_usps.rates.find(function(
                    element
                ) {
                    return (
                        element.rateCode == rateCodeNew || element.rateName == rateCodeNew
                    )
                })
            }

            if (typeof foundRate === 'undefined' || foundRate === null) {
                foundRate = { rateCode: rateCode, rateName: rateCodeNew }
            }
            return foundRate
        },
      isRateFullPay: function(rateCode) {

            let foundRate = false;

            var rateCodeNew = rateCode;
            if(this.cruise.rederij_id === '25') {
              rateCodeNew = rateCode.substring(rateCode.length - 3)
            }

            if (this.cruise.ratecode_usps.directFullPayRates) {
                foundRate = this.cruise.ratecode_usps.directFullPayRates.find(function(
                    element
                ) {
                    return (
                        element === rateCodeNew
                    )
                })
            }

            if (typeof foundRate === 'undefined' || foundRate === null) {
                foundRate = false
            }
            return foundRate
        },
        // checks available rates to see if we might need to setup new ratecodes
        checkRates: function() {
            let self = this
            // if we have usps rates
            if (this.cruise.ratecode_usps.rates) {
                Object.keys(this.availableRates).forEach(function(rateCode) {
                    // loop through all available rates
                    let rateName = self.availableRates[rateCode]

                    // look for available rates in usps rate object
                    let foundRate = self.cruise.ratecode_usps.rates.find(
                        function(element) {
                            return (
                                element.rateCode === rateName ||
                                element.rateCode === rateCode
                            )
                        }
                    )

                    // if not found send notice to anaylics
                    if (
                        typeof foundRate === 'undefined' ||
                        foundRate === null
                    ) {
                        self.$store.dispatch('saveLog', {
                            error: false,
                            track: true,
                            messages: [
                                'Rate metainfo unset: ' +
                                    rateName +
                                    ' code: ' +
                                    rateCode,
                            ],
                        })
                    }
                })
            }
        },
        // used to display a list of passenger names
        paxInfoToNameArray: function(paxInfo) {
            let ret = []
            if (!paxInfo || !paxInfo.collection) return ''
            paxInfo.collection.forEach(function(pax) {
                let name = ''
                if (pax.voornaam !== null) {
                    name += pax.voornaam
                }
                if (pax.tussenvoegsel !== null) {
                    name += ' ' + pax.tussenvoegsel
                }
                if (pax.achternaam !== null) {
                    name += ' ' + pax.achternaam
                }
                if (name !== '') {
                    ret.push(name)
                }
            })
            return ret.join(', ')
        },
        // cleanup cabin names
        cabinName: function(cabinName) {
            if (typeof cabinName === 'undefined') {
                return 'Onbekend'
            }
            return cabinName
        },
        // is cabinNumber a guarantee cabin without cabinnumber select
        isGuaranteeCabin: function(cabinNumber) {
          // if (this.cabins && this.cabins.selected && this.cabins.selected.apiData && this.cabins.selected.apiData.cabinStatus) {
          //   return this.cabins.selected.apiData.cabinStatus === 'GA';
          // }

          if (!cabinNumber) return false
          return cabinNumber[0] === 'G'
        },
        sendDataLayer: function(data, event_name = 'start_payment'){
          dataLayer.push({
            "duration": data.cruise.duur,
            "date": data.cruise.begindatum,
            "price": data.totalPrice,
            "component": "cruise",
            "basket": {
              "id": 0,
              "price": data.totalPrice,
              "quantity": 1
          },
            "booking_id": false,
            "product_id": data.cruise.cruise_id,
            "instance_parent": data.cruise.rederij_naam,
            "instance": data.cruise.schip_naam,
            "currency": "EUR",
            "title": data.cruise.titel,
            "image": data.cruise.schip_img,
            "highlight": data.cruise.cruise_usps,
            "alias": "/onlineboeken/" + data.cruise.cruise_id,

            "thema": data.cruise.thema_naam,
            "country": "",
            "region": data.cruise.bestemming_naam,
            "region_id": data.cruise.bestemming_id,
            "city": "",

            'page': '/onlineboeken',
            'loggedIn': 'false',
            'identifier': '',
            'page_category': 'boeken',
            'country_code': 'nl',
            'lang_code': 'nl',
            'customer_id': '',
            'event': event_name,
            'user_id': ''
          });

        },
        // rounds the price and outputs NL financial notation
        roundPrice: function(price) {
            if (!price) return '-'
            if (isNaN(price)) return '?'
            let parsed = price.toFixed(2)
            return this.numberWithCommas(
                parsed
                    .split('.')
                    .join(',')
                    .replace(',00', ',-')
            )
        },
        // used for NL financial notation replace . with , and vica versa
        numberWithCommas: function(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        // if  local departure and step count above flight steps
        modifierAfterFlights: function(number) {
            if (this.cruise.isLocalDeparture && number >= 6) {
                return number - 2
            }
            return number
        },
        // if local departure or no flights offered change step increment
        skipFlightsIfneeded: function(stepCount) {
            if (this.cruise.isLocalDeparture) stepCount = 8
            this.activeStep = stepCount
            this.highestStep = stepCount
          this.setBlinkyBlink()
        },
        // returns string with selected cabin number or garantiehut
        displayCabinNumber: function(cabinNumber) {
            if (cabinNumber === undefined) return ''
            if (cabinNumber === undefined) return ''
            if (this.isGuaranteeCabin(cabinNumber)) return 'Garantiehut'
            return this.cabinNumbers.selected
        },
        setPeopleAndStep: function(step) {
            if (this.peopleChanged) {
                this.resetCabinConfig()
                if (step > 4) {
                    this.highestStep = 4
                    this.setActiveStep(4)
                } else {
                    this.highestStep = step
                    this.setActiveStep(step)
                }
                this.peopleChanged = false
            } else {
                this.setActiveStep(step)
            }
        },

        // changes the current booking process step
        setActiveStep: function(step) {
            let self = this
            $.when($('.scroll-arrow').show()).done(function() {
                if (step <= self.highestStep) {
                    self.activeStep = step
                    if (self.highestStep < step) self.highestStep = step
                } else {
                    let prevStep = self.highestStep
                    if (self.cruise.isLocalDeparture && step > 7) {
                        prevStep -= 2
                    }
                    // @todo improve UX
                  if(prevStep === 3) {
                    prevStep = 2
                    self.activeStep = prevStep;
                  }
                    alert('Maak eerst een keuze in stap: ' + prevStep + '.')

                }
            })
          this.setBlinkyBlink();

        },
      setBlinkyBlink: function() {
        let that = this
        that.blinkyBlink = true
        setTimeout(function() {
          that.blinkyBlink = false
        }, 1000)
      },

        //scrolls to direction
        scrollElement: function(element, amount) {
            var current_position = $(element).scrollLeft() // get current y position of element

            var animateTime = 500 // default animation time

            // if amount is false (meaning no anmiation should occur, and just check if left or right button should be hidden)
            if (amount === false) animateTime = 0 //set animation time to zero to disable animation

            //only allow animation of element is not being animated alread
            if (!$(element).is(':animated')) {
                //animate element
                $(element).animate(
                    { scrollLeft: current_position + amount },
                    {
                        duration: animateTime, //set animation time
                        complete: function() {
                            //check if left button should be show or hidden
                            if (
                                (current_position === $(element).scrollLeft() &&
                                    $(element).scrollLeft() <= 0) ||
                                $(element).scrollLeft() <= 0
                            ) {
                                $(element)
                                    .find('.scroll-left')
                                    .first()
                                    .hide()
                            } else {
                                $(element)
                                    .find('.scroll-left')
                                    .first()
                                    .show()
                            }

                            //check if right button should be show or hidden
                            if (
                                (current_position !== $(element).scrollLeft() &&
                                    $(element).scrollLeft() > 0) ||
                                this.scrollWidth - this.clientWidth ===
                                    $(element).scrollLeft()
                            ) {
                                $(element)
                                    .find('.scroll-right')
                                    .first()
                                    .hide()
                            } else {
                                $(element)
                                    .find('.scroll-right')
                                    .first()
                                    .show()
                            }
                        },
                    }
                )
            }
        },
        // change binnenhut/buitenhut/balkonhut/suite
        changeCabinType: function(cabinType) {
            if (!this.payload) return false
            this.payload.cabins[0].cabinType = cabinType
            // this.cabins.selected.code = false
            // this.cabins.selected.name = false
            this.highestStep = 4
            this.activeStep = 4
            this.showPrice = false

            this.setActiveStep(3)
        },
        // Change selected cabin
        selectCabin: function(cabin) {
            if (typeof cabin === 'undefined') {
                return false
            }
            this.payload.cabins[0].cabinType = cabin.type
            this.payload.cabins[0].cabinCode = cabin.code
            this.cabins.selected = cabin
        },
        // Change selected cabin and move on
        confirmCabin: function(cabin) {
            this.selectCabin(cabin)
            this.highestStep = 5
            this.showPrice = true
            this.activeStep = 5
            this.cabinNumbers = {}
            this.getCabinNumbers()
            this.setActiveStep(5)
        },
      // Change selected cabin and move on
        confirmCabinCheapest: function(cabin) {
            this.selectCabin(cabin)
            this.highestStep = 6
            this.showPrice = true
            this.activeStep = 6
            this.cabinNumbers = {}
            this.getCabinNumbers()
            this.skipFlightsIfneeded(6)
        },
    },
    updated: function() {
        this.$nextTick(function() {
            this.scrollElement('#cabin-select', false)
            this.scrollElement('#cabin-detail-select', false)
        })

      if(this.activeStep === 3 && this.availabilityReceived &&
          this.availableRates &&
          Object.keys(this.availableRates).length === 0 &&
          this.ajaxCalls === 0) {
        this.setActiveStep(4);
      }
    },
    mounted: function() {
        this.getStarterPack()

      $('body').on('click', '.resize-image', function() {
        console.log('click');
        if($('#imageModal').length === 0) {
          $('body').append('<div id="imageModal"></div>');
        }

        var image = $(this).attr('src');

        var imageModal = $('#imageModal');
        imageModal.html('<img src="' +  image + '">');
        imageModal.show();
      })
      $('body').on('click', '#imageModal', function() {
        $(this).hide();
      })
    },
    created: function() {
        const paxCount = this.getPaxcount
        if (paxCount) {
            this.payload.cabins[0].volwassenen = paxCount.volwassenen
            this.payload.cabins[0].jeugd = paxCount.jeugd
            this.payload.cabins[0].baby = paxCount.baby
            this.payload.cabins[0].kinderen = paxCount.kinderen
        }

        const hut = this.getHutType
        if (hut && hut.cabinType) {
            this.payload.cabins[0].cabinType = hut.cabinType
        }

        console.log(this.$route.params)

        if (this.$route.params.hutType) {
            this.setActiveStep(2)
            this.payload.cabins[0].cabinType = this.$route.params.hutType
        } else {
          this.setActiveStep(1)
        }
        if (this.$route.params.rate) {
            this.payload.rateCode = this.$route.params.rate
        }
    },
  beforeMount()  {

      // var cruiseIds = [
      //   "881141",
      //   "881133",
      //   "881132",
      //   "881134",
      //   "881140"
      // ];
      //
      // if(cruiseIds.includes(this.$route.params.id)) {
      //   document.location = "/cruise/" + this.$route.params.id;
      // }
  }
}
</script>
<style>
.active_list {
  column-count: 3;
  column-fill: auto;
  width: 500px;
  overflow: hidden;
  height: 230px;
}

.item {
  width: 100%;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
  z-index: 1011100;
}

.tooltip .tooltiptext {
  visibility: hidden;
  background-color: #fff3cd;
  border: solid 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  border-radius: 6px;
  padding: 5px;

  position: absolute;
  z-index: 11111111;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
.notification-cabin {
  margin: 13px 0 !important;
  background-color: #fff3cd;
  padding: 15px 15px 10px;
  border-radius: 5px;
  border: 1px solid #fff3cd;
}
.notification-cabin p {
  margin-top: 5px !important;
  color: #856404 !important;
}

p,
a,
div {
    color: #333333;
}
@media only screen and (max-width: 500px) {
    .paxinfoBox {
        margin-right: 12px;
    }
}
.editbutton {
  background-color: transparent !important;
  color: #333 !important;
  border: 0 !important;
  box-shadow: unset !important;
  text-transform: unset !important;
  font-size: 12px !important;
}
.editbutton:hover {
  text-decoration: underline;
}
#imageModal {
  position: fixed;
  top:0;
  left:0;
  right:0;
  width:100%;
  bottom:0;
  background: rgba(0,0,0,0.4);
  display: flex;
  flex-flow:column;
  justify-content: center;
}
#imageModal img {
  width:100%;
  max-width:600px;
  margin:auto;
  border-radius:5px;
}
.resize-image {
  position:relative;
  cursor: zoom-in;
}
.resize-image:after {
  content: '1';
  top:3px;
  right:3px;
  position: fixed;
}


@media screen and (max-width: 740px) {
  .pricecentermobile {
    width:100% !important;
    text-align: center;
    margin-bottom:10px;
  }
  .pricecentermobile + button {
    width:100% !important;
  }
  .mobile-100 {
    width:100% !important;
  }
  .rotate-on-mobile {
    display: flex;flex-flow:column;
    flex-direction: column-reverse;
  }
  .sidebar-ups {
    display:none;
  }
  .mobile-mb {
    margin-bottom: 10px;
  }
  #content {
    padding-top:0 !important;
  }
}

</style>
<style lang="scss">
.stepheader {
  width:100%;

  background:#fff;

  border-block: 1px solid #efefef;
  & > div {
    max-width:1200px;
    margin:auto;
    margin-block:20px;
    display:flex;
    & > div {
      width: calc(100% / 7);
      padding-inline:5px;
      box-sizing:border-box;
      .numberHeaderContainer {
      text-align: center;
        width:100%;
        display:flex;
        flex-flow:column;
        .numberHeaderSubtitle {
          font-size: 14px;
          width:100%;
          max-width:100%;
        }
        .numberHeader {

          margin: auto auto 6px;
        }
      }
    }
  }
}
.hoverme {

  cursor:pointer;
  &:hover {
    &.midblock, .midblock, {
     border-color: #afc9da;
      background-color: #f3f9fd;
      .btn-success {
        background-color: #da7a00;
      }
    }

  }
}
.hoverme tr:hover {
  border-color: #afc9da;
  background-color: #f3f9fd;
  .btn-success {
    background-color: #da7a00;
  }
}
u {
  cursor:pointer;
}

</style>
